import React from "react";

import {DropdownMenuItem} from "@reside/ui";

import {getResidentTestId} from "../../helper";
import {
  AdmissionFromSearch,
  downloadAdmissionPdf,
} from "../../../../services/AdmissionsService";
import {useDownloadManager} from "../../../../hooks/useDownloadManager";

export const DownloadPDFDropdownItem = ({
  admission,
  ...props
}: {
  admission: AdmissionFromSearch;
}) => {
  const {start} = useDownloadManager();

  return (
    <DropdownMenuItem
      pointer
      onClick={() => {
        start("Download Admission", () =>
          downloadAdmissionPdf({
            admissionId: admission.id,
            type: "full",
            status: admission.status,
          }),
        );
      }}
      testId={getResidentTestId(admission, "downloadPdf")}
      {...props}
    >
      Download Admission
    </DropdownMenuItem>
  );
};
